<template>
  <div class="bottom">
    <div class="btm-panel">
      <div class="intro">
        <img class="logo" src="/static/image/logo_foot@2x.png" />
        <div class="tag-panel">

          <div class="tag c2">
            <div class="item">{{navs.hxjsNavs.title}}</div>
            <div class="item a" v-for="(item,index) in navs.hxjsNavs.subTitle " :key="index" @click="pushView(item,2)">{{ item.title }}</div>
          </div>
          <div class="tag c3">
            <div class="item">{{navs.cpzxNavs.title}}</div>
            <div class="item a" v-for="(item,index) in navs.cpzxNavs.subTitle " :key="index" @click="pushView(item,3)">{{ item.title }}</div>
  
          </div>
          <div class="tag c1">
            <div class="item">{{navs.newsNavs.title}}</div>
            <div class="item a" v-for="(item,index) in navs.newsNavs.subTitle " :key="index" @click="pushView(item,4)">{{ item.title }}</div>
  
          </div>
          <div class="tag c4">
            <div class="item">{{navs.supportNavs.title}}</div>
            <div class="item a" v-for="(item,index) in navs.supportNavs.subTitle " :key="index" @click="pushView(item,5)">{{ item.title }}</div>
          </div>
          <div class="tag c4">
            <div class="item">{{navs.joinusNavs.title}}</div>
            <div class="item a" v-for="(item,index) in navs.joinusNavs.subTitle " :key="index" @click="pushView(item,6)">{{ item.title }}</div>
          </div>
          <div class="tag c1" >
            <div class="item">{{navs.aboutNavs.title}}</div>
            <div class="item a" v-for="(item,index) in navs.aboutNavs.subTitle " :key="index" @click="pushView(item,1)">{{ item.title }}</div>
  
          </div>
          <div class="tag c5">
            <div class="item">联系方式</div>
            <div class="item a">
              地址：南京市鼓楼区清江南路18号鼓楼创新广场D栋18层
            </div>
            <div class="item a">电话：400-1331-551</div>
            <div class="item a">邮箱：business@cnewmedical.com</div>
          </div>
          <div class="logo-foot">
            <div class="logo-foot_c">
              <img class="t_image" src="/static/image/img_gongzhonghao@2x.png" />
              <div class="label">关注晨新医疗公众号</div>
            </div>
            <div class="logo-foot_c">
              <img class="t_image" src="/static/image/img_gongzhonghao2@2x.png" />
              <div class="label">关注晨新致远公众号</div>
            </div>
            <div class="logo-foot_c">
              <img class="t_image" src="/static/image/img_gongzhonghao_peizhenhui@2x.png" />
              <div class="label">关注陪诊汇公众号</div>
            </div>
     
          </div>
        </div>
      </div>
      <div class="copy">
        <div class="value">
          版权所有 © 2022 晨新医疗 cnewmedical 苏ICP备2023047460号-1
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState,mapMutations } from "vuex";
export default {
  data() {
    return {
      localIndex: -1,
      activedMenu: 0,
      navs: {
  
        hxjsNavs: {
          title: "核心技术",
          subTitle: [
            {
              title: "核心技术",
              path: "coreTechnology",
              selectedNuber:0
            },
            {
              title: "5大优势",
              path: "5Key",
              selectedNuber:1
            },
            {
              title: "原研算法",
              path: "algorithm",
              selectedNuber:2
            },
          ],
        },
        cpzxNavs: {
          title: "产品中心",
          subTitle: [
            {
              title: "内窥镜摄像系统解决方案",
              path: "programme",
              selectedNuber:0
            },
            {
              title: "智能会议平板解决方案",
              path: "pad",
              selectedNuber:1
            },
            {
              title: "数字一体化手术室解决方案",
              path: "operatingRoom",
              selectedNuber:2
            }
          ],
        },
        newsNavs: {
          title: "新闻中心",
          subTitle: [
            {
              title: "新闻中心",
              path: "news",
            }
          ],
        },
        supportNavs: {
          title: "服务支持",
          subTitle: [
            {
              title: "服务支持",
              path: "support",
              selectedNuber:0
            }
          ],
        },
       joinusNavs: {
          title: "加入我们",
          subTitle: [
            {
              title: "职位探索",
              path: "position",
              selectedNuber:0
            },
            {
              title: "福利待遇",
              path: "welfare",
              selectedNuber:1
            },
            // {
            //   title: "办公环境",
            //   path: "environment",
            //   selectedNuber:2
            // },
            {
              title: "联系我们",
              path: "contactUs",
              selectedNuber:2
            },
          ],
        },
        aboutNavs: {
          title: "关于晨新",
          subTitle: [
            {
              title: "关于晨新",
              path: "aboutCnew",
              selectedNuber:0
            },
            {
              title: "发展历程",
              path: "hostory",
              selectedNuber:1
            },
            // {
            //   title: "资质荣誉",
            //   path: "honour",
            //   selectedNuber:2
            // },
          ],
        },
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    pushView(item,type){
      window.localStorage.setItem('index', type);
      this.$router.push({ name: item.path ,params:{
        selectedNuber:item.selectedNuber
      }});
    }
  },
};
</script>

<style lang="scss" scoped>
.bottom {
  height: 302px;
  width: 100%;
  // position: absolute;
  bottom: 0px;
  margin-top: 100px;
  // background: #EFEFEF;
  background: linear-gradient( 180deg, #186DD5 0%, #0549A2 100%);
  border-radius: 0px 0px 0px 0px;
  .btm-panel {
    display: flex;
    justify-content: center;
    width: 100%;
    height: calc(100% - 1px);
    position: relative;
    .intro {
      display: flex;
      box-sizing: border-box;
      padding: 24px 0px 0px 0px;
      flex-direction: column;
      position: relative;
      .logo {
        width: 90px;
        margin-bottom: 24px;
        height: 38px;
      }
      .tag-panel {
        display: flex;
        margin-top: 2px;
        margin-left: 5px;
        .tag {
          display: flex;
          margin-right: 40px;
          flex-direction: column;
          .item {
            cursor: pointer;
            width: 100%;
            text-align: left;
            font-size: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            // color: #333333;
            color: white;
            margin-bottom: 8px;
          }
          .a {
            font-size: 12px;
            font-weight: 400;
          }
        }
        .c1 {
          width: 56px;
        }
        .c2 {
          width: 76px;
        }
        .c3 {
          width: 145px;
          margin-right: 36px;
        }
        .c4 {
          margin-right: 43px;
        }
        .c5 {
          width: 320px;
        }
        .logo-foot {
          display: flex;
          margin-left: 103px;
          display: flex;
          flex-direction: row;
          .logo-foot_c{
           
           display: flex;
           flex-direction: column;
           justify-content: center;
           align-items: center;
           width: 150px;
           img {
            width: 100px;
            height: 100px;
            margin-bottom: 8px;
          }
         }
      
          .label {
            width: 126px;
            height: 19px;
            text-align: center;
            font-size: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            // color: #333333;
            color: white;
          }
        }
      }
    }
    .copy {
      display: flex;
      width: 100%;
      position: absolute;
      margin-top: 46px;
      line-height: 36px;
      height: 16px;
      bottom: 8px;
      justify-content: center;
      align-items: center;
      .value {
        font-size: 12px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        // color: #333333;
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue